import { IHttpService, ILocationService, IScope } from "angular";

angular.module('logbook')
	.controller('reset-password', ['$scope', '$http', '$location',
		function($scope: IScope, $http: IHttpService, $location: ILocationService) {

			$scope.passwordReset = {
				email: $location.search().email,
				code: $location.search().code
			};

			$scope.doPasswordReset = () => {
				delete $scope.resetPasswordError;

				$http.post('api/passwordReset', $scope.passwordReset, {
					noErrorPopup: true
				})
				.then(
					() => $location.url('/'),
					error => $scope.resetPasswordError = error
				);
			};
		}]
	);


angular.module('logbook').directive('passwordValidate', function() {
	return {
		require: 'ng-model',
		link: function(scope, element, attr, mCtrl) {
			function validate(value?: string) {
				function result() {
					if (typeof value !== 'string') return false;
					
					if (!(/.*[a-z]/g).test(value)) {
						return false;
					}
					if (!(/.*[A-Z].*/g).test(value)) {
						return false;
					}
					if (!(/.[0-9].*/g).test(value)) {
						return false;
					}
					if (!(/.{8,}/g).test(value)) {
						return false;
					}
					return true;
				}
				
				const r = result();
				mCtrl?.$setValidity('password', r);
				return value;
			}
			
			mCtrl?.$parsers.push(validate);
		}
	}
})